import { Box, Typography, IconButton } from "@mui/material";
import { Emoji } from "emoji-picker-react";
import CloseIcon from "@mui/icons-material/Close";
import { IconActionButton } from "../../input/button";

const PlannerTaskItem = ({ task, onComplete, onEdit, onRemove }) => {
  const { title, completed, emoji } = task;

  return (
    <Box
      className={`planner-task ${completed ? "planner-task--completed" : ""}`}
    >
      <Box className="planner-task__header">
        {emoji && (
          <span className="planner-task__emoji">
            <Emoji unified={emoji} size={18} />
          </span>
        )}
        <Typography variant="body2" className="planner-task__title">
          {title}
        </Typography>
      </Box>
      <Box className="planner-task__actions">
        {onRemove && (
          <IconButton
            size="small"
            onClick={(e) => {
              e?.stopPropagation?.();
              onRemove(task);
            }}
            className="planner-task__remove"
          >
            <CloseIcon sx={{ fontSize: 20 }} />
          </IconButton>
        )}
        {onEdit && (
          <IconActionButton
            icon="edit"
            color="orange"
            onClick={(e) => {
              e?.stopPropagation?.();
              onEdit(task);
            }}
          />
        )}
        {onComplete && (
          <IconActionButton
            icon="tick"
            color="green"
            onClick={(e) => {
              e?.stopPropagation?.();
              onComplete(task);
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default PlannerTaskItem;
